import { ESRI } from '@rsos/constants/mapProviders';
import { createCircleGeometry } from '../../providers/esri/geometry/circles';
import { createGraphic } from '../../providers/esri/graphics/graphic/createGraphic';
import updateCircle from './updateCircle';

/**
 * Creates and returns a circle instance based on the map provider
 * @param {Object} mapObject - map object
 * @param {Object} options - options for the circle
 * @param {Array} options.center - options for the circle
 * @param {Number} options.radius - radius of circle
 */
const createCircle = async ({
  mapObject,
  circleOptions = {},
  graphicOptions = {},
  callback,
}) => {
  switch (mapObject.mapProvider) {
    case ESRI: {
      return createCircleGeometry({
        configs: {
          ...circleOptions,
          radiusUnit: circleOptions.radiusUnit
            ? circleOptions.radiusUnit
            : 'meters',
          geodesic: true,
        },
      }).then(circleGeometry => {
        return createGraphic({
          mapObject,
          configs: {
            geometry: circleGeometry.circle,
            ...graphicOptions,
            layer: circleOptions.layer,
          },
        }).then(circleSymbol => {
          const circle = {
            instance: circleSymbol.graphic,
            ...(circleOptions.custom
              ? { custom: { ...circleOptions.custom } }
              : {}),
            changeCircleColor: opts => {
              updateCircle({
                mapObject,
                circle: circleSymbol.graphic,
                options: opts,
              });
            },
          };
          if (callback) {
            callback(circle);
          } else {
            return circle;
          }
        });
      });
    }
    default:
      return null;
  }
};

export default createCircle;
